import ContentLoader from 'components/content/ContentLoader';

interface TableSkeletonProps {
    id: string;
    tableHeaders: Record<string, React.ReactNode>;
}

const TableSkeleton = ({ id, tableHeaders }: TableSkeletonProps) => (
    <div data-testid={`system-admin-table-skeleton-${id}`} className='display-flex flex-column'>
        <table className='table-head-filled table-bordered table'>
            <thead>
                <tr>
                    {Object.values(tableHeaders).map(label => (
                        <th key={label + 'header'}>{label}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <tr>
                    {Object.values(tableHeaders).map(label => (
                        <td key={label + 'body'}>
                            <ContentLoader height='16px' width='60%' />
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    </div>
);

export default TableSkeleton;
